import { inject } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { from, switchMap } from 'rxjs';
import { UserRepository } from '@app/repositories';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) =>
{
    const userRepository = inject(UserRepository);

    return from(userRepository.getAuthToken())
        .pipe(
            switchMap((token) =>
            {
                if (!token)
                {
                    return next(req.clone());
                }

                let headers = req.headers;

                if (!headers.has('Authorization'))
                {
                    headers = headers.append('Authorization', `Bearer ${token}`);
                }

                return next(req.clone({
                    headers,
                }));
            }),
        );
}
